<div id="shipment-route-table-container" class="matp-table-container tw-max-h-full">
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <button mat-raised-button id="filter-clear-btn" class="tw-mr-2" (click)="clearFilters()">
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        class="tw-mr-2"
        color="primary"
        (click)="created.emit()"
        [disabled]="loadingMasterData"
      >
        @if (loadingMasterData) {
          <mat-icon class="tw-animate-spin">progress_activity</mat-icon>
        } @else {
          <mat-icon>add</mat-icon>
        }
        <span>新規追加</span>
      </button>
      <button
        mat-raised-button
        id="delete-all-btn"
        color="warn"
        class="tw-mr-2"
        (click)="bulkDelete()"
        [disabled]="isBulkDeleteButtonDisable"
      >
        <mat-icon>delete</mat-icon>
        <span>一括削除</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="shipment-route-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef class="matp-table-header-middle !tw-min-w-min">
          <mat-checkbox
            name="selectAll"
            color="primary"
            (change)="$event ? toggleAllRows() : null; updateBulkDeleteButtonState()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            name="select"
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null; updateBulkDeleteButtonState()"
            [checked]="selection.isSelected(element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="shipmentName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">配送名</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="shipmentName"
              type="text"
              [(ngModel)]="shipmentNameKeyword"
              (keyup)="applyFilter()"
            />
            <button id="shipment-name-filter-clear-btn" matSuffix mat-icon-button (click)="clearShipmentNameFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.shipmentName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="startLocation">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">出発地</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="startLocation"
              type="text"
              [(ngModel)]="startLocationKeyword"
              (keyup)="applyFilter()"
            />
            <button id="start-location-filter-clear-btn" matSuffix mat-icon-button (click)="clearStartLocationFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.route.startLocation?.locationName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="arrivalLocation">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">到着地</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="arrivalLocation"
              type="text"
              [(ngModel)]="arrivalLocationKeyword"
              (keyup)="applyFilter()"
            />
            <button id="arrival-location-filter-clear-btn" matSuffix mat-icon-button (click)="clearArrivalLocationFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.route.arrivalLocation?.locationName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">デバイス名</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="deviceName"
              type="text"
              [(ngModel)]="deviceNameKeyword"
              (keyup)="applyFilter()"
            />
            <button id="device-name-filter-clear-btn" matSuffix mat-icon-button (click)="clearDeviceNameFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ getDeviceNames(element.deviceList) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">配送ステータス</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              name="status"
              panelClass="matp-table-select-panel"
              [(ngModel)]="selectedShipmentStatus"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (uniqueStatus of uniqueStatusList; track uniqueStatus) {
                @if (getShipmentStatusFilterLabel(uniqueStatus)) {
                  <mat-option [value]="uniqueStatus">
                    {{ getShipmentStatusFilterLabel(uniqueStatus) }}
                  </mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-whitespace-nowrap">
          {{ getShipmentStatusLabel(element.status) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="repeatSetting">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">繰り返し設定</div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ getRepeatSettingLabel(element.frequency) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">更新日時</div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (element.updatedAt) {
            {{ element.updatedAt | date: 'yyyy/MM/dd HH:mm:ss' }}
          } @else {
            -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-px-2">
          <div class="tw-flex tw-justify-center">
            <button
              mat-stroked-button
              id="edit-btn"
              color="primary"
              (click)="updated.emit(element)"
              [disabled]="loadingMasterData"
            >
              @if (loadingMasterData) {
                <mat-icon class="tw-animate-spin">progress_activity</mat-icon>
              } @else {
                <mat-icon>edit</mat-icon>
              }
              <span>編集</span>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="shipment-route-table-paginator"
    [length]="dataSource.filteredData.length"
    [pageSize]="10"
    hidePageSize
    showFirstLastButtons
  ></mat-paginator>
</div>
